import router from "./routers";
import {useStore} from "../store";

//  定义路由白名单
const whiteList = [ '/home']

//  创建路由守卫
router.beforeEach((to, from, next) => {
    const store = useStore()
    
    // 如果访问根路径，直接跳转到主页/home
    if (to.path === '/' || !to.path){
        next({path: '/home'})
        return
    }
    
    // 已登录
    if (store.token){
        if (to.path === '/login'){
            next({path: '/Layout'})
        } else {
            next()
        }
    } else {
        // 未登录
        if (whiteList.indexOf(to.path) !== -1){
            next()
        } else {
            next({ path: '/home' })
        }
    }
})